import { useEffect, useState } from 'react';

function useOutsideClick(ref) {
  const [outClick, setOutClick] = useState(false);
  useEffect(() => {
    function handleOutsideClick(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOutClick(true);
      }
    }
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [ref]);

  return { outClick, setOutClick };
}

export default useOutsideClick;
